import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config;
    const isAuthCall = orig?.url?.startsWith("/auth/");
    if (error.response?.status === 401 && orig && !orig._retry && !isAuthCall && orig.url.startsWith("/admin")) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(orig);
      } catch (e) {
        refreshing = null;
        window.dispatchEvent(new Event("auth:logout"));
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(e, fallback = "Si è verificato un errore. Riprova.") {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message && !e.response ? "Connessione non riuscita. Riprova." : fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => (d && typeof d.msg === "string" ? `${(d.loc || []).slice(-1)[0] || ""}: ${d.msg}` : "")).filter(Boolean).join(" · ");
  }
  if (typeof detail?.msg === "string") return detail.msg;
  return fallback;
}

export async function downloadFile(path, params, fallbackName) {
  const res = await api.get(path, { params, responseType: "blob" });
  const disp = res.headers["content-disposition"] || "";
  const match = disp.match(/filename="([^"]+)"/);
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = match ? match[1] : fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
